import { lazyLoadView } from '@router/routes'
import { i18n } from '@plugins/i18n'
import { ROLE } from '@utils/constant'

const friendListRoutes = {
  path: 'frield-list',
  component: {
    render(c) {
      return c('router-view')
    },
  },
  meta: {
    label: i18n.t('router.friend.list'),
  },
  children: [
    {
      path: '',
      name: 'friendList',
      component: () => lazyLoadView(import('@views/FriendList/list.vue')),
      meta: {
        authRequired: [ROLE.SUPER],
      },
    },
  ],
}

export default friendListRoutes
